"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const processorGetControlListItemContextById = ({ controlId, rootProcessor, }) => { var _a; return (_a = rootProcessor.getControlRunContext(controlId)) === null || _a === void 0 ? void 0 : _a.itemContext; };
exports.default = processorGetControlListItemContextById;
